import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import profile from "./profile";
import members from "./members";
import teams from "./teams";
import permissions from "./permissions";
import customization from "./customization";
import rfqNotifications from "./rfqNotifications";
import contactBlacklist from "./contactBlacklist";

export default combineReducers({
  auth,
  message,
  profile,
  members,
  teams,
  permissions,
  customization,
  rfqNotifications,
  contactBlacklist,
});
